declare namespace $ {

	type $mol_view__style_shm_ba_chart_timeseries_1 = $mol_type_enforce<
		({ 
			'left': ReturnType< $shm_ba_chart_timeseries['plot_left_style'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_ba_chart_timeseries_2 = $mol_type_enforce<
		ReturnType< $shm_ba_chart_timeseries['tools_left'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__Filter_shm_ba_chart_timeseries_3 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__value_shm_ba_chart_timeseries_4 = $mol_type_enforce<
		ReturnType< $shm_ba_chart_timeseries['group'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_ba_chart_timeseries_5 = $mol_type_enforce<
		ReturnType< $shm_ba_chart_timeseries['group_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_view__sub_shm_ba_chart_timeseries_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_echarts__option_shm_ba_chart_timeseries_7 = $mol_type_enforce<
		ReturnType< $shm_ba_chart_timeseries['option'] >
		,
		ReturnType< $shm_echarts['option'] >
	>
	type $shm_echarts__brush_cursor_shm_ba_chart_timeseries_8 = $mol_type_enforce<
		ReturnType< $shm_ba_chart_timeseries['brush_cursor'] >
		,
		ReturnType< $shm_echarts['brush_cursor'] >
	>
	type $shm_echarts__click_shm_ba_chart_timeseries_9 = $mol_type_enforce<
		ReturnType< $shm_ba_chart_timeseries['bar_click'] >
		,
		ReturnType< $shm_echarts['click'] >
	>
	type $shm_echarts__brush_end_shm_ba_chart_timeseries_10 = $mol_type_enforce<
		ReturnType< $shm_ba_chart_timeseries['brush_end'] >
		,
		ReturnType< $shm_echarts['brush_end'] >
	>
	type $shm_echarts__finished_shm_ba_chart_timeseries_11 = $mol_type_enforce<
		ReturnType< $shm_ba_chart_timeseries['chart_finished'] >
		,
		ReturnType< $shm_echarts['finished'] >
	>
	export class $shm_ba_chart_timeseries extends $mol_view {
		plot_left_style( ): string
		tools_left( ): readonly(any)[]
		Left_tools( ): $mol_view
		group( next?: string ): string
		Group_select( ): $mol_select
		Tools( ): $mol_view
		option( ): any
		brush_cursor( ): any
		bar_click( next?: any ): any
		brush_end( next?: any ): any
		chart_finished( next?: any ): any
		Chart( ): $shm_echarts
		rows( ): readonly(any)[]
		title( ): string
		group_options( ): Record<string, any>
		period_pick( next?: any ): any
		period_range_pick( next?: any ): any
		overlay_rows( ): readonly(any)[]
		overlay_title( ): string
		overlay_series( ): readonly(any)[]
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=timeseries.view.tree.d.ts.map